import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDFH-N7rkXqyfVg7szgDhCcYkdxJP_FNyk",
  authDomain: "facilitation-assessment.firebaseapp.com",
  projectId: "facilitation-assessment",
  storageBucket: "facilitation-assessment.firebasestorage.app",
  messagingSenderId: "274316989423",
  appId: "1:274316989423:web:da69d079783eb8c6555c1a",
  measurementId: "G-X6S1GKW2YG"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
